/**
 * Event times are wall-clock times in Spain (the events happen at a fixed
 * local time regardless of who's viewing the page). We encode the digits the
 * organizer enters directly as UTC when saving, and always read them back
 * via the UTC getters. That way the displayed time is identical no matter
 * what timezone the server process or the visitor's browser is running in —
 * which also avoids SSR/CSR hydration mismatches from date-fns' `format`
 * otherwise using each side's local timezone.
 */

const MADRID_TZ = "Europe/Madrid";

export function parseEventDateTimeLocal(value: string): Date {
  return new Date(`${value}:00.000Z`);
}

export function eventDateTimeLocalValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
}

export function toDisplayDate(date: Date): Date {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}

/** "Now", expressed as a fake-UTC wall-clock time in Madrid, for comparing against stored event times. */
export function nowAsEventTime(): Date {
  const madrid = new Date().toLocaleString("sv-SE", { timeZone: MADRID_TZ });
  return new Date(`${madrid.replace(" ", "T")}Z`);
}
